/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * moovy-saas-api
 * OpenAPI spec version: 1.0.0
 */
import type {
  Cuid,
  ListPublicScenariosByTenantParams,
  PublicScenarioSummary,
  ScenarioWithNodesAndVideoUrls,
  SurveyImpressionInput,
  SurveyResponseInput,
  SurveyResponseResponse,
  SurveySubmissionInput,
} from '.././model'

import {
  default as getPublicScenarioMutator,
  default as listPublicScenariosByTenantMutator,
  default as recordSurveyImpressionMutator,
  default as submitSurveyFormMutator,
  default as submitSurveyResponseMutator,
} from '../../../customFetch'

/**
 * 公開プレイリスト一覧を取得（sitemap生成用）
指定テナントの公開済みプレイリスト（displayType=SLIDER/TILE）のみを返します。
動画署名URLは含めない軽量レスポンスです。
 */
export const listPublicScenariosByTenant = (params: ListPublicScenariosByTenantParams) => {
  return listPublicScenariosByTenantMutator<PublicScenarioSummary[]>({
    url: `/public/scenarios`,
    method: 'GET',
    params,
  })
}
/**
 * 公開シナリオを取得
公開されているシナリオのみを取得できます。
非公開のシナリオにアクセスすると401エラーを返します。
各ノードには動画の署名付きURL（24時間有効）が含まれます。
 */
export const getPublicScenario = (scenarioId: Cuid) => {
  return getPublicScenarioMutator<ScenarioWithNodesAndVideoUrls>({
    url: `/public/scenarios/${scenarioId}`,
    method: 'GET',
  })
}
/**
 * アンケート回答を保存
公開シナリオの視聴中に視聴者が回答した設問の結果を記録します。
(sessionId, questionId) の行集合を置換するため多重送信・回答変更は最新で上書きされます
（SINGLE/MULTI/FREE 共通）。
リード（PII）項目の設問では leadValue を回答とは別の専用テーブルへ隔離保存します（ADR-0010・ADR-0012）。
非公開シナリオへの送信は存在秘匿のため success:true の no-op になります。
 */
export const submitSurveyResponse = (scenarioId: Cuid, surveyResponseInput: SurveyResponseInput) => {
  return submitSurveyResponseMutator<SurveyResponseResponse>({
    url: `/public/scenarios/${scenarioId}/survey-responses`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: surveyResponseInput,
  })
}
/**
 * アンケートフォームを一括送信（PII 混在・#264）
SURVEYノードの全画面ゲートで、非PII設問（回答表）とリード項目（PII・リード表）が混在する
フォーム全体を単一トランザクションで atomic に振り分け保存します（部分保存なし・送信時のみ）。
必須設問が1つでも未回答ならフォーム全体を 400 で拒否します（「答えた人だけ次へ」の権威的判定）。
非公開シナリオへの送信は存在秘匿のため success:true の no-op になります。
 */
export const submitSurveyForm = (scenarioId: Cuid, surveySubmissionInput: SurveySubmissionInput) => {
  return submitSurveyFormMutator<SurveyResponseResponse>({
    url: `/public/scenarios/${scenarioId}/survey-submissions`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: surveySubmissionInput,
  })
}
/**
 * アンケートの提示到達を記録（到達→完了ファネル用・ADR-0015）

SURVEYノードの全画面ゲートと動画紐づきアンケート（シート）の両方から呼ぶ。
視聴セッション × テンプレ × 紐づけ先で重複排除するので、何度提示されても1件。
 */
export const recordSurveyImpression = (scenarioId: Cuid, surveyImpressionInput: SurveyImpressionInput) => {
  return recordSurveyImpressionMutator<SurveyResponseResponse>({
    url: `/public/scenarios/${scenarioId}/survey-impressions`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: surveyImpressionInput,
  })
}
export type ListPublicScenariosByTenantResult = NonNullable<Awaited<ReturnType<typeof listPublicScenariosByTenant>>>
export type GetPublicScenarioResult = NonNullable<Awaited<ReturnType<typeof getPublicScenario>>>
export type SubmitSurveyResponseResult = NonNullable<Awaited<ReturnType<typeof submitSurveyResponse>>>
export type SubmitSurveyFormResult = NonNullable<Awaited<ReturnType<typeof submitSurveyForm>>>
export type RecordSurveyImpressionResult = NonNullable<Awaited<ReturnType<typeof recordSurveyImpression>>>
